<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-6 bg-transparent justify-center">
    <div class="flex flex-wrap">

      <!-- Heading -->
      <h2 class="md:min-w-full text-blueGray-400 text-sm uppercase font-bold block pt-6 pb-4 no-underline">
        BINLA EDUCATION
      </h2>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card1" @mouseover="zoomIn('card1')" @mouseleave="zoomOut('card1')">
        <router-link to="/binla_book">
          <img src="@/assets/img/binla_book.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Binla Book
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ book_result }} Lessons
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card2" @mouseover="zoomIn('card2')" @mouseleave="zoomOut('card2')">
        <router-link to="/binla_channel">
          <img src="@/assets/img/binla_channel.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Binla Channel
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ channel_result }} Videos
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-6/12 mr-auto px-4 pt-6 pb-6 mb-2">
      </div>

      <!-- กั้นระหว่าง Binla และ Dahla -->


      <!-- Heading -->
      <h2 class="md:min-w-full text-blueGray-400 text-sm uppercase font-bold block pt-6 pb-4 no-underline">
        DAHLA SERVICE
      </h2>
      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card3" @mouseover="zoomIn('card3')" @mouseleave="zoomOut('card3')">
        <router-link to="/dahla_calendar">
          <img src="@/assets/img/dahla_calendar.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Dahla Calendar
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ calendar_arr.calendar }} Subjects/Subject Groups
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card4" @mouseover="zoomIn('card4')" @mouseleave="zoomOut('card4')">
        <router-link to="/dahla_elog">
          <img src="@/assets/img/dahla_e-log.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Dahla E-Log
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ elog_arr.elog }} Subjects/Subject Groups
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card5" @mouseover="zoomIn('card5')" @mouseleave="zoomOut('card5')">
        <router-link to="/dahla_co_act">
          <img src="@/assets/img/dahla_co-act.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Dahla Co-Act
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ co_act_arr.co_act }} Activities
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card6" @mouseover="zoomIn('card6')" @mouseleave="zoomOut('card6')">
        <router-link to="/dahla_alumni">
          <img src="@/assets/img/dahla_alumni.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Dahla Alumni
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            Number of Alumni {{ alumni_arr.alumni }} Persons
          </h2>
        </router-link>
      </div>

      <div class="w-full lg:w-3/12 mr-auto px-4 pt-6 pb-6 mb-2 shadow-lg rounded-lg border-0 bg-white card-zoom"
        ref="card7" @mouseover="zoomIn('card7')" @mouseleave="zoomOut('card7')">
        <router-link to="/dahla_smartgrade">
          <img src="@/assets/img/dahla_smartgrade.png" style=" max-width: 70px!important; border-radius: 0.3rem;">
          <h2 class="text-blueGray pt-6 text-xl font-semibold text-blueGray">
            Dahla SmartGrade <small v-if="edu_year_arr.edu_year_grade != edu_year_arr.edu_year">({{ edu_year_arr.edu_year_grade }})</small>
          </h2>
          <h2 class="text-blueGray text-lg pt-2 text-blueGray">
            {{ smartgrade_arr.smartgrade }} Subjects
          </h2>
        </router-link>
      </div>

    </div>
  </div>
</template>


<script>
import api from './../../services/student_services';
export default {
  name: "card-zoom",
  data() {
    return {
      openTab: 1,
      elog_arr: [],
      subject_arr: [],
      binlabook_arr: [],
      binlachannel_arr: [],
      channel_result: [],
      book_result: [],
      alumni_arr: [],
      calendar_arr: [],
      co_act_arr: [],
      smartgrade_arr: [],
      edu_year_arr: []
    }
  },
  methods: {
    zoomIn(refName) {
      // const cardName = document.getElementById(refName);
      const cardElement = this.$refs[refName];
      cardElement.style.transform = 'scale(1.05)';
    },
    zoomOut(refName) {
      // const cardName = document.getElementById(refName);
      const cardElement = this.$refs[refName];
      cardElement.style.transform = "scale(1)";
    },
    async elog() {
      api.elog().then(async (result) => {
        this.elog_arr = result.data;
      });
    },
    async subject() {
      api.subject().then(async (result) => {
        this.subject_arr = result.data;
      });
    },
    async binlachannel() {
      api.binlachannel().then(async (result) => {
        this.binlachannel_arr = result.data;
        this.channel_result = this.binlachannel_arr.binlachannel;
      });
    },
    async binlabook() {
      api.binlabook().then(async (result) => {
        this.binlabook_arr = result.data;
        this.book_result = this.binlabook_arr.binlabook;

      });
    },
    async alumni() {
      api.alumni().then(async (result) => {
        this.alumni_arr = result.data;

      });
    },

    async calendar() {
      api.calendar().then(async (result) => {
        this.calendar_arr = result.data;

      });
    },

    async co_act() {
      api.co_act().then(async (result) => {
        this.co_act_arr = result.data;

      });
    },

    async smartgrade() {
      api.smartgrade().then(async (result) => {
        this.smartgrade_arr = result.data;
      });
      api.edu_year().then(async (result) => {
        this.edu_year_arr = result.data;
      });
    }


  }, created: async function () {
    await this.elog(),
      await this.subject(),
      await this.binlabook(),
      await this.binlachannel(),
      await this.alumni(),
      await this.calendar(),
      await this.co_act(),
      await this.smartgrade()
  }

};
</script>